<template>
     <!-- 编辑单位用户 -->
     <el-dialog title="单位管理员" width="90%" :visible.sync="dialogVisible" :close-on-click-modal="false" destroy-on-close>
        <el-row>
          <el-col :span="5" class="cla">
            <el-form :model="unitUserInfo" ref="unitUserForm" :rules="rules" size="small">
              <el-form-item label="所属部门" :inline="true" prop="fullName">
                <el-select v-model="selectDeptId" filterable placeholder="请选择部门" style="width:100%">
                  <el-option v-for="item in deptOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="姓名" :inline="true" prop="fullName">
                <el-input v-model="unitUserInfo.fullName" placeholder="请输入姓名" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="账户名" :inline="true" prop="userName">
                <el-input v-model="unitUserInfo.userName" :disabled="unitUserInfo.isEdit" placeholder="请输入账户名（PC登录使用）" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="手机号" :inline="true" prop="phoneNumber">
                <el-input v-model="unitUserInfo.phoneNumber" :disabled="unitUserInfo.isEdit" placeholder="请输入手机号（初始密码）" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱" :inline="true" prop="email">
                <el-input v-model="unitUserInfo.email" placeholder="请输入电子邮箱" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="备注" :inline="true" prop="remarks">
                <el-input v-model="unitUserInfo.remarks" placeholder="请输入备注" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item style="text-align: right;">
                <el-button size="mini" type="primary" @click="saveUnitUserFunc()">保存</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="18">
                <el-table :data="tableData" style="width: 100%" height="500px" size="mini" :highlight-current-row="true" @row-click="userRowClick">
                  <el-table-column prop="fullName" label="姓名" width="120" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="userName" label="账户名" width="170" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="phoneNumber" label="手机号" width="150" show-overflow-tooltip> </el-table-column> 
                  <el-table-column prop="email" label="电子邮箱" width="150" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="openId" label="微信标识" width="140" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="remarks" label="备注" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="createTime" label="创建时间" width="160" show-overflow-tooltip> </el-table-column>
                  <el-table-column prop="ops" label="操作" fixed="right" width="120"> 
                    <template slot-scope="scope">
                      <el-button @click="resetPassword(scope.row)" type="text" size="small">重置密码</el-button>
                      <el-button @click="deleteUnitUserFunc(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                  </el-table-column>
              </el-table>
              <el-pagination style="float: left;" :page-sizes="tablePage.pageSizeList" layout="prev,pager,next" @current-change="changePage" @size-change="changeSize" :total="tablePage.tableCount"></el-pagination>   
          </el-col>
        </el-row>
        


        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取 消</el-button>
          <el-button size="small" type="primary" :loading="loading">确 定</el-button>
        </div>
      </el-dialog>  
</template>

<script>
import { Message,MessageBox } from 'element-ui';
import { listUnitDept } from "@/api/dept";
import { listUnitUser,saveUnitUser,deleteUnitUser,resetUnitSystemPassword } from "@/api/unitUser";

export default {
  name: "UnitUserDialog",
  props: {
    dialogVisible: false,
    deptOptions: [],
    selectUnitId: null,
    selectUnitCode:null,
  },
  data(){
    return {
      rules: {
            fullName: [
              { required: true, message: "请输入姓名", trigger: "blur" },
            ],
            userName: [
              { required: true, message: "请输入账户名", trigger: "blur" },
            ],
            phoneNumber: [
              { required: true, message: "请输入手机号码", trigger: "blur" },
            ],
      },
      selectDeptId: null,
      currentUnitCode:null,
      loading:false,
      tableData: [],
      tablePage : {
        pageNum: 1,
        pageSize: 10,
        tableCount: 50,
        pageSizeList: [10,20]
      },
      unitUserInfo : {
        id: '',
        deptId:'',
        fullName:'',
        userName:'',
        phoneNumber:'',
        email:'',
        remarks:'',
        isEdit: false,
      },
      query: {
        deptId: "",
        phoneNumber: "",
        fullName: "",
        tagList: []
      },



    }
  },
  mounted(){
    
  },
  created() {
    this.selectDeptId = this.$props.selectUnitId;
    this.currentUnitCode = this.$props.selectUnitCode;
    this.getUnitUserPage();
  },
  watch : {
    selectUnitCode(new_,old_){
       this.currentUnitCode = new_;
       this.unitUserInfo = {
        id: '',
        deptId:'',
        fullName:'',
        userName:'',
        phoneNumber:'',
        email:'',
        remarks:'',
        isEdit: false,
      }
      this.getUnitUserPage();
    },
    selectUnitId(new_,old_){
       this.selectDeptId = new_;
    }
  },
  methods: {
    
     //获取数据
     getUnitUserPage(){
        let where = this.query;
            where.pageNum = this.tablePage.pageNum;
            where.pageSize = this.tablePage.pageSize;
            where.hasAdmin = 1;
            where.unitCode = this.currentUnitCode;
        listUnitUser(where).then(res => {
            this.tableData = res.data.content;
            this.tablePage.tableCount = res.data.totalElements;
        });
    },
    
     //切换分页
    changePage(val1){
        this.tablePage.pageNum = val1;
        this.getUnitUserPage();
    },

    //切换分页
    changeSize(val) {
        this.tablePage.pageSize = val;
        this.getUnitUserPage();
    },

    //打开新增用户弹窗
    closeDialog(){
      this.$emit('close');
    },

    //保存用户信息
    saveUnitUserFunc(){
      let this_ = this;
      this_.$refs.unitUserForm.validate((valid) => {
          if(valid){
            let param = {...this_.unitUserInfo}  
                param.unitId = this_.selectDeptId;
                param.hasAdmin = 1;
            this_.loading = true;
            saveUnitUser(param).then(res => {
                this_.loading = false;
                if(res.code == 200){
                    Message.success('保存成功');
                    this_.getUnitUserPage(); 
                } else {
                    Message.error(res.msg);
                }
            });
          } 
      });
    },

    //获取部门选择下拉框
    getDeptInfos(){
      listUnitDept({}).then(res => {
        this.deptOptions = res.data;
      });
    },

    //点击
    userRowClick(res) {
        this.unitUserInfo = {
          id: res.id,
          fullName: res.fullName,
          userName: res.userName,
          phoneNumber: res.phoneNumber,
          email: res.email,
          remarks: res.remarks,
          isEdit: true,
        }
        console.log(res);
    },

    //删除用户
    deleteUnitUserFunc(row){
      let this_ = this;
      MessageBox.confirm('此操作将永久删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteUnitUser(row).then((res) => {
                if(res.code == 200){
                   Message.success('处理成功'); 
                   this_.getUnitUserPage();
                } else {
                   Message.error(res.msg);
                }
          });
        }).catch(() => {
                  
      });
    },

    //重置密码
    resetPassword(row){
      let id = row.id;
      MessageBox.prompt('请输入重置后密码', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'password',
          inputValidator:(val) => {
              if(val == '' || val == null){
                  return '密码不能为空';
              }
          }
      }).then(({ value }) => {
        resetUnitSystemPassword({userId:id,password:value}).then(res => {
            if(res.code == 200){
               Message.success("操作成功"); 
            } else {
               Message.success(res.msg); 
            }
        });
      }).catch(() => {
               
      });
    },
    
  },
};
</script>


<style>
 .cla {
    margin-right: 10px;
    border-right: 1px #6666662b dashed;
    padding-right: 10px;
 }
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/UnitSysUserDialog.vue